import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Inject, Input, OnInit } from '@angular/core';
import { CustomerDto } from '@dto/customerDto';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomersService } from '@services/entity/customers.service';
import { UsersService } from '@services/entity/users.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import { OnboardingRequest } from '@dto/onboardingRequest';
import { UserDto } from '@dto/userDto';
import { MasterUserOfCustomer } from '@dto/masterUserOfCustomer';
import { AuthenticationService } from '@services/authentication/authentication.service';

@Component({
  selector: 'app-invite-customer-dialog-content',
  templateUrl: './invite-customer-dialog-content.component.html',
  styleUrls: ['./invite-customer-dialog-content.component.scss'],
  providers: [FormService]
})
export class InviteCustomerDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'InviteCustomerDialogContentComponent';

  @Input() public customerId: number;
  public customer: CustomerDto;
  public masterUser: MasterUserOfCustomer;

  public isUser: boolean = false;
  public isCustomer: boolean = false;
  public isOperator: boolean = false;
  public formCreated: boolean;
  public isButtonDisabled: boolean = false;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    public activeModal: NgbActiveModal,
    public dialog: NgbModal,
    public formService: FormService,
    private customersService: CustomersService,
    private usersService: UsersService,
    public toastService: ToastService,
    public authenticationService: AuthenticationService,
    injector: Injector) {
    super(activeModal, injector);
  }

  async ngOnInit() {
    this.getRoles();
    super.ngOnInit;
    this.customersService.getMasterUserOfCustomer(this.customerId).subscribe(masterUser => {
      this.masterUser = masterUser;
    })
    this.createForm();
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      confirmName: new UntypedFormControl(false, [Validators.requiredTrue]),
      confirmEmail: new UntypedFormControl(false, [Validators.requiredTrue]),
      confirmChargingStations: new UntypedFormControl(false, [Validators.requiredTrue]),
      confirmRfid: new UntypedFormControl(false, [Validators.requiredTrue]),
    });
    this.formCreated = true;
  }

  onSubmit() {
    this.sendInvitation();
  }

  sendInvitation() {
    this.toastService.loading("Einladung wird versendet...", true);
    this.isButtonDisabled = true;

    this.customersService
      .invite(this.masterUser.customerId, { baseUrl: `${this.baseUrl}auth/welcome/${this.masterUser.id}` })
      .subscribe((response: any) => {
        this.toastService.clear();
        this.isButtonDisabled = false;

        this.toastService.success($localize`:@@InviteHasBeenSendMessage:Einladung wurde verschickt.`);
        this.close();
      }, error => {
        this.toastService.clear();
        this.isButtonDisabled = false;
        console.error(error);
        this.toastService.error($localize`:@@InviteCouldNotBeSendMessage:Einladung konnte nicht verschickt werden.`)
      })
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Customer')) this.isCustomer = true;
    if (this.authenticationService.userHasRole('User')) this.isUser = true;
  }

  close() {
    this.activeModal.close();
  }
}
